/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorissueinvalid3Inputs */

const en_menueditorissueinvalid3 = /** @type {(inputs: Menueditorissueinvalid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something is not right yet. Check the entries.`)
};

const de_menueditorissueinvalid3 = /** @type {(inputs: Menueditorissueinvalid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das passt so noch nicht. Prüf die Einträge.`)
};

/**
* | output |
* | --- |
* | "Something is not right yet. Check the entries." |
*
* @param {Menueditorissueinvalid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorissueinvalid3 = /** @type {((inputs?: Menueditorissueinvalid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorissueinvalid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorissueinvalid3(inputs)
	return de_menueditorissueinvalid3(inputs)
});
export { menueditorissueinvalid3 as "menuEditorIssueInvalid" }